import React from "react";
import { HashRouter, Routes, Route, Link } from 'react-router-dom';
import styles from './app.module.css';
import logout from './logout.svg';
import logo from './logo.svg'

import Map from '../3d-map/3d-map';
import Home from '../home/home'

export default function App() {
    return (
        <HashRouter>
            <header>
                <Link to="/">
                    <img src={logo} height={62} />
                </Link>
                <div className={styles.user}>
                    <div className={styles.userInfo}>
                        <div className={styles.userName}>Oleg Blohin</div>
                        <div className={styles.userRole}>CTO</div>
                    </div>
                    <img src={logout} height={42}></img>
                </div>
            </header>
            <Routes> {/* The Switch decides which component to show based on the current URL.*/}
                {/* <Route exact path="/" element={<Home />} />
                <Route exact path="/map" element={<Map />} /> */}
                <Route exact path="/" element={<Map />} />
                {/* <Route exact path='/signup' component={Signup}></Route> */}
            </Routes>
        </HashRouter>
    );
}